import type { ApiResponse } from '@creator/sdk/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';

export interface PostViewApiRequestPayload {
    postId: string;
    tokenName: string;
    userId: string;
}

export const postView = async (payload: PostViewApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<{ postId: string }>>(
        '/post/view',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false,
    );
    return data.payload;
};
